/**
 * Sprogsider (/en, /ar, /uk) — registret.
 *
 * REGLER:
 *  1. Priser og varigheder skrives ALDRIG i sprogfilerne. De hentes fra courseGroups.js,
 *     så dansk og fremmedsprog aldrig kan vise to forskellige tal.
 *  2. Kun forløb, der faktisk kan tages på fremmedsprog, sælges her. Taxa er medtaget
 *     som en ærlig oplysningsside: dansk på niveau med Prøve i Dansk 2 er et lovkrav.
 *  3. Slugs er på sidens eget sprog (brugerens valg) — engelske ord på /en, arabisk
 *     skrift på /ar, kyrillisk på /uk. Google afkoder URL'en og viser den læsbart.
 */

import en from "./en";
import ar from "./ar";
import uk from "./uk";

export const LANG_PACKS = { en, ar, uk };
export const LANG_CODES = ["en", "ar", "uk"];

/** Sprogsidens kursusnøgle → kursusgruppens danske slug (courseGroups.js). */
export const LANG_COURSE_MAP = {
  "haulier-truck": "vognmand-lastbil",
  "haulier-van": "vognmand-varebil",
  "van-driver-basic": "vb-gu",
  "van-driver-refresher": "vb-eu",
  "taxi-driver": "taxa",
};

export const COURSE_KEYS = Object.keys(LANG_COURSE_MAP);

export const getLangPack = (code) => LANG_PACKS[code] || null;

export const getLangCourseByKey = (code, key) => {
  const pack = LANG_PACKS[code];
  return pack?.courses?.[key] || null;
};

/** Finder kursusnøglen ud fra sprogsidens egen slug (URL kan være %-kodet). */
export const findLangCourse = (code, rawSlug) => {
  const pack = LANG_PACKS[code];
  if (!pack || !rawSlug) return null;
  let slug = rawSlug;
  try {
    slug = decodeURIComponent(rawSlug);
  } catch (e) {
    slug = rawSlug;
  }
  const key = COURSE_KEYS.find((k) => pack.courses[k]?.slug === slug);
  return key ? { key, course: pack.courses[key] } : null;
};

/** Sti til en sprogside (rå, ikke kodet, til react-router <Link to>). */
export const langCoursePath = (code, key) => {
  const c = getLangCourseByKey(code, key);
  return c ? `/${code}/${c.slug}` : `/${code}`;
};

/** Absolut, %-kodet URL, til canonical, hreflang og sitemap. */
export const langCourseUrl = (siteUrl, code, key) => {
  const c = getLangCourseByKey(code, key);
  return c ? `${siteUrl}/${code}/${encodeURIComponent(c.slug)}` : `${siteUrl}/${code}`;
};

/**
 * hreflang-sæt for et kursus: alle sprogvarianter + den danske side som x-default.
 */
export const courseAlternates = (siteUrl, key) => {
  const danish = `${siteUrl}/kurser/${LANG_COURSE_MAP[key]}`;
  return [
    { hrefLang: "da", href: danish },
    ...LANG_CODES.filter((c) => getLangCourseByKey(c, key)).map((c) => ({
      hrefLang: c,
      href: langCourseUrl(siteUrl, c, key),
    })),
    { hrefLang: "x-default", href: danish },
  ];
};

/** hreflang-sæt for sprogforsiderne. */
export const indexAlternates = (siteUrl) => [
  { hrefLang: "da", href: `${siteUrl}/kurser` },
  ...LANG_CODES.map((c) => ({ hrefLang: c, href: `${siteUrl}/${c}` })),
  { hrefLang: "x-default", href: `${siteUrl}/kurser` },
];

export default LANG_PACKS;
